import { monthlyTickInterval } from './monthly_trend_axis.js';

export const chart_dates = {}; // 图表横轴的日期与报告数据之间的映射关系

export function resetDates () {
  for (const key in chart_dates) {
    delete chart_dates[key];
  }
}

export function getInterval(index, value) {
  return monthlyTickInterval(Object.keys(chart_dates).length)(index);
}
